module.exports = __webpack_public_path__ + "img/vul.94a7b30c.png";